import { render, staticRenderFns } from "./TradingGroup.vue?vue&type=template&id=47598c3e&scoped=true"
import script from "./TradingGroup.vue?vue&type=script&lang=js"
export * from "./TradingGroup.vue?vue&type=script&lang=js"
import style0 from "./TradingGroup.vue?vue&type=style&index=0&id=47598c3e&prod&scoped=true&lang=css"
import style1 from "./TradingGroup.vue?vue&type=style&index=1&id=47598c3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47598c3e",
  null
  
)

export default component.exports